import React, { Component } from 'react';

class ModalMensaje extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {
            mensaje,
            titulo
        } = this.props;


        // ACTIONS
        const{
            mostrarOcultarModal
        } = this.props

        return (
            <div className='modalContainer'>
                <div className='modal-content'>
                    <h2 className="modal-header" style={{ "height": "70px"}}>{titulo}</h2>
                    <div className='modal-body' style={{ "width": "600px"}}>
                        {mensaje}
                    </div>

                    <div className='modal-footer'>
                        <button onClick={() => mostrarOcultarModal(false)} className="btn btn-primary btn-cta">Aceptar</button>
                    </div>
                </div>
            </div>
        )
            ;
    }
}

export default ModalMensaje;
